var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('HamburgerMenu'),_c('Hero'),(_vm.toggleMenu)?_c('Header'):_vm._e(),_c('About'),_c('Facts'),_c('Skills'),_c('Resume'),_c('Portfolio'),_c('Services'),_c('Contact'),_c('Footer'),_c('ScrollOnTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }